<template>
  <v-container fluid class="px-0">
    <form
      @keydown.enter.prevent="searchRegistras()"
      @keydown.esc.prevent="cancelData()"
    >
      <v-row align="baseline" class="mb-4">
        <template v-if="showFail">
          <v-col cols="12">
            <v-alert dense outlined type="error">
              {{ failMsg }}
            </v-alert>
          </v-col>
        </template>

        <template v-if="turtasRole">
          <v-col cols="12" md="4">
            <el-text-field
              label="Registro numeris"
              tooltip="Hipoteka. Turtas. NTR. Registro numeris. Paieškai"
              :readonly="isSearching"
              :placeholder="regNrPlaceholder"
              v-mask="regNrMask"
              v-model="searchData.reg_nr"
              autofocus
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              label="Unikalus numeris"
              tooltip="Hipoteka. Turtas. NTR. Unikalus numeris. Paieškai"
              :readonly="isSearching"
              v-model="searchData.reg_obj_kodas"
            />
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12" md="6">
            <el-role-negalima />
          </v-col>
        </template>
        <v-col cols="12" md="4">
          <el-button
            v-if="turtasRole"
            primary
            @click.native="searchRegistras()"
            :loading="loading"
            :disabled="isSearching"
            >Ieškoti registre</el-button
          >
          <el-button
            @click.native="cancelData()"
            :loading="loading"
            :disabled="isSearching"
            >Atšaukti</el-button
          >
        </v-col>
        <v-col cols="12" md="8">
          <el-button
            :loading="loading"
            :disabled="isSearching"
            @click.native="searchAsmuo()"
            >Įkelti asmens turtus</el-button
          >
          <el-button
            :loading="loading"
            :disabled="isSearching"
            @click.native="searchSkolininkas()"
            >Įkelti skolininko turtus</el-button
          >
        </v-col>
      </v-row>
    </form>
    <template v-if="showResult">
      <v-data-table
        :headers="filteredHeaders"
        :items="filteredItemsList"
        :loading="loading"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :items-per-page="pageSize"
      >
        <template #top>
          <v-toolbar flat>
            <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label=""
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item, index }">
          <!-- <tr v-for="teise in item.teises" :key="`${item.tei_id}`"> -->
          <tr :key="`row-${item.reg_id}-${item.tei_id}-${index}`" valign="top">
            <td class="pt-6 pb-2">{{ item.reg_nr }}</td>
            <td class="pt-6 pb-2">{{ item.unikalus_nr }}</td>

            <td class="py-2">
              <el-checkbox
                :key="`teise-${item.reg_id}-${item.tei_id}-${index}`"
                v-model="item.aktyvus"
                @click.native="checkTeise(item)"
              >
                <template slot="label">
                  <div class="teise-label">
                    <template v-if="item.teit_tipas === 1">
                      <p class="teise-bold">{{ item.tei_pavadinimas }}</p>
                      <p>{{ item.adresas }}</p>
                    </template>
                    <template v-else>
                      <p>{{ item.tei_pavadinimas }}</p>
                      <p>{{ item.adresas }}</p>

                      <p
                        v-if="item.tei_pradzios_data || item.tei_pabaigos_data"
                      >
                        Galioja
                        <span v-if="item.tei_pradzios_data">
                          nuo {{ item.tei_pradzios_data }}
                        </span>
                        <span v-if="item.tei_pabaigos_data">
                          iki {{ item.tei_pabaigos_data }}
                        </span>
                      </p>
                      <p v-if="item.tei_terminas_nuo || item.tei_terminas_iki">
                        Terminas
                        <span v-if="item.tei_terminas_nuo">
                          nuo {{ item.tei_terminas_nuo }}
                        </span>
                        <span v-if="item.tei_terminas_iki">
                          iki {{ item.tei_terminas_iki }}
                        </span>
                      </p>
                      <p>
                        {{ item.doku_pav }}
                        <span v-if="item.dok_nr"> Nr. {{ item.dok_nr }} </span>
                      </p>
                    </template>
                  </div>
                </template>
              </el-checkbox>
            </td>
            <td class="pt-2 pb-2 asmuo">
              <template>
                <div
                  v-for="dalis in item.filteredDalys"
                  :key="`dalisdiv-${item.tei_id}-${dalis.dal_id}`"
                >
                  <el-checkbox
                    :key="`dalis-${item.tei_id}-${dalis.dal_id}`"
                    :label="
                      `${dalis.dal_skaitiklis}/${dalis.dal_vardiklis} ${dalis.pavadinimas}`
                    "
                    @click.native="checkDalis(item, dalis)"
                    v-model="dalis.aktyvus"
                  />
                </div>
              </template>
            </td>
          </tr>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>

      <v-footer class="form-footer mt-3">
        <el-button
          primary
          @click.native="saveData(null, 'close')"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button @click.native="cancelData()" :loading="loading"
          >Atšaukti</el-button
        >
        <v-spacer></v-spacer>
      </v-footer>
    </template>
    <modal-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="asmuoRole"
      :salys="salys"
      @savedData="savedAsmuo"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import unsavedData from '../../../mixins/unsavedData'
import { regNrMaskFilter } from '../../../mixins/regNrMask'
import ModalAsmuo from '../../modals/ModalAsmuo'

export default {
  name: 'TurtasNtrSearch',
  props: {
    turtasRole: Boolean,
  },
  components: {
    ModalAsmuo,
  },
  mixins: [unsavedData],
  data() {
    return {
      searchData: {
        registro_nr: null,
        reg_obj_kodas: null,
      },
      formData: [],
      isSearching: false,
      loading: false,
      showFail: false,
      failMsg: null,
      showResult: false,
      regNrPlaceholder: '##/#########',
      regNrMask: regNrMaskFilter,
      RegistroNr: null,
      showAsmuo: false,
      modalAsmuoRefresh: 0,
      modalAsmuo: {},
      salys: [],
      search: null,
      itemsPerPageOptions: [10, 50],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'turtasID', 'turtasRusis']),
    compMask() {
      return [/\d/, /(\d|\/)/, '/', /\d/, /\d/]
    },
    searchTipas() {
      if (
        this.searchData.reg_obj_kodas &&
        this.searchData.reg_obj_kodas.length > 0
      ) {
        return 'unikalus_numeris'
      } else {
        return 'registro_numeris'
      }
    },
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    regNr() {
      return this.searchData.reg_nr ?? (this.isLocal ? '57/9388' : null)
    },
    reg_obj_kodas() {
      return this.searchData.reg_obj_kodas
    },

    headers() {
      return [
        {
          text: 'Nekilnojamojo turto registro numeris',
          align: 'start',
          value: 'reg_nr',
          sortable: false,
          width: 150,
        },
        {
          text: 'Unikalus numeris',
          align: 'start',
          value: 'unikalus_nr',
          sortable: false,
          width: 150,
        },
        {
          text: 'Turto rūšis',
          align: 'start',
          sortable: false,
          value: 'turtasFilter',
        },
        {
          text: 'Įkaito davėjas',
          align: 'start',
          sortable: false,
          value: 'dalisFilter',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    hideFooter() {
      return this.formData.length <= 10
    },
    itemsList() {
      return this.formData.map(item => {
        item.turtasFilter = item.tei_pavadinimas + ' ' + item.adresas

        if (item.teit_tipas !== 1) {
          item.turtasFilter +=
            item.tei_pradzios_data + ' ' + item.tei_pabaigos_data
          if (item.tei_pradzios_data || item.tei_pabaigos_data) {
            item.turtasFilter += ` Galioja ${
              item.tei_pradzios_data ? 'nuo ' + item.tei_pradzios_data : ''
            } ${item.tei_pradzios_data ? 'iki ' + item.tei_pabaigos_data : ''}`
          }
          if (item.tei_terminas_nuo || item.tei_terminas_iki) {
            item.turtasFilter += ` Terminas ${
              item.tei_terminas_nuo ? 'nuo ' + item.tei_terminas_nuo : ''
            } ${item.tei_terminas_iki ? 'iki ' + item.tei_terminas_iki : ''}`
          }
          item.turtasFilter += ' ' + item.doku_pav + ' Nr. ' + item.dok_nr
        }

        item.dalisFilter = ''
        item.dalys = item.dalys.map(dalis => {
          dalis.pavadinimas = dalis.asmenys
            .map(asmuo => {
              return asmuo.asm_pavadinimas
            })
            .join(', ')

          dalis.dalisFilter =
            dalis.dal_skaitiklis +
            '/' +
            dalis.dal_vardiklis +
            ' ' +
            dalis.pavadinimas +
            ' '
          item.dalisFilter += dalis.dalisFilter
          return dalis
        })

        return item
      })
    },
    filteredItemsList() {
      return this.itemsList.map(item => {
        item.filteredDalys = item.dalys.filter(dalis => {
          return (
            !this.search ||
            dalis.dalisFilter.toLowerCase().includes(this.search.toLowerCase())
          )
        })
        if (item.filteredDalys.length === 0) {
          item.filteredDalys = item.dalys
        }
        return item
      })
    },
    autoSearch() {
      return this.$route.params.autoSearch
    },
    autoSearchTurID() {
      return this.$route.params.autoSearchTurID
    },
    modalAsmuoKey() {
      return `asmuo-${this.modalAsmuoRefresh}`
    },
    asmuoRole() {
      return 'ntr-search'
    },
  },
  created() {
    this.makeAutoSearch()
  },
  methods: {
    searchRegistras() {
      let data = {}
      if (
        this.searchData.reg_obj_kodas &&
        this.searchData.reg_obj_kodas.length > 0
      ) {
        data = {
          paieskos_tipas: this.searchTipas,
          reg_obj_kodas: this.reg_obj_kodas,
        }
      } else {
        data = {
          paieskos_tipas: this.searchTipas,
          reg_nr: this.regNr,
        }
      }
      this.searchTurtas(data)
    },
    searchSkolininkas() {
      const data = {
        paieskos_tipas: 'skolininkas',
      }
      this.searchTurtas(data)
    },
    searchAsmuo() {
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/pilietybes/list`)
        .then(res => {
          this.salys = res.data.salys
          this.modalAsmuo = {
            sasm_id: null,
          }
          this.modalAsmuoRefresh++
          this.showAsmuo = true
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    savedAsmuo(modalAsmuo) {
      this.showAsmuo = false
      const data = {
        paieskos_tipas: 'asmuo',
        amn_id: modalAsmuo.amn_id,
        amnt_tipas: modalAsmuo.amnt_tipas,
      }
      this.searchTurtas(data)
    },
    searchTurtas(data) {
      this.loading = true
      this.showResult = false

      this.$axios
        .post(`objektas/${this.objektasID}/turtas/search-ntr`, data)
        .then(res => {
          this.formData = res.data.turtai
          this.showResult = true
          this.showFail = false
          window._VMA.$emit('DATA_OK', res.data.message)

          this.initialForm()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    makeAutoSearch() {
      if (this.autoSearch) {
        this.searchData.reg_obj_kodas = this.autoSearch
        const data = {
          paieskos_tipas: 'unikalus_numeris',
          reg_obj_kodas: this.autoSearch,
        }
        this.searchTurtas(data)
      }
    },

    // itemsList_old(dataList) {
    //   let items = []
    //   dataList.forEach(registras => {
    //     let { teises2, ...registrasItem } = registras
    //     let teises = []

    //     let nuosavybeItem = null
    //     registras.teises.forEach(teise => {
    //       item.aktyvus = false
    //       item.obj_kodas = registras.obj_kodas
    //       item.reg_id = registras.reg_id
    //       item.reg_nr = registras.reg_nr
    //       item.unikalus_nr = registras.unikalus_nr
    //       item.adresas = registras.adresas

    //       item.turtasFilter = item.tei_pavadinimas + ' ' + item.adresas

    //       if (item.teit_tipas !== 1) {
    //         item.turtasFilter +=
    //           item.tei_pradzios_data + ' ' + item.tei_pabaigos_data
    //         if (item.tei_pradzios_data || item.tei_pabaigos_data) {
    //           item.turtasFilter += ` Galioja ${
    //             item.tei_pradzios_data ? 'nuo ' + item.tei_pradzios_data : ''
    //           } ${
    //             item.tei_pradzios_data ? 'iki ' + item.tei_pabaigos_data : ''
    //           }`
    //         }
    //         if (item.tei_terminas_nuo || item.tei_terminas_iki) {
    //           item.turtasFilter += ` Terminas ${
    //             item.tei_terminas_nuo ? 'nuo ' + item.tei_terminas_nuo : ''
    //           } ${
    //             item.tei_terminas_iki ? 'iki ' + item.tei_terminas_iki : ''
    //           }`
    //         }
    //         item.turtasFilter += ' ' + item.doku_pav + ' Nr. ' + item.dok_nr
    //       }
    //       // item.asmenysFilter = ''
    //       // item.asmenysPavadinimas = ''
    //       // item.asmenys = item.asmenys.map(asmuo => {
    //       //   asmuo.aktyvus = false
    //       //   asmuo.dal_skaitiklis = item.dal_skaitiklis
    //       //   asmuo.dal_vardiklis = item.dal_vardiklis
    //       //   item.asmenysFilter += asmuo.asm_pavadinimas + ' '
    //       //   return asmuo
    //       // })
    //       item.asmuo = [
    //         {
    //           aktyvus: false,
    //           dal_skaitiklis: item.dal_skaitiklis,
    //           dal_vardiklis: item.dal_vardiklis,
    //           pavadinimas: item.asmenys
    //             .map(asmuo => {
    //               return asmuo.asm_pavadinimas
    //             })
    //             .join(', '),
    //           amnIdList: item.asmenys.map(asmuo => {
    //             return asmuo.amn_id
    //           }),
    //         },
    //       ]
    //       item.asmenysFilter =
    //         item.dal_skaitiklis +
    //         '/' +
    //         item.dal_vardiklis +
    //         ' ' +
    //         item.asmuo[0].pavadinimas

    //       if (item.teit_tipas === 1) {
    //         let { asmuo, ...teiseItem } = teise
    //         if (!nuosavybeItem) {
    //           nuosavybeItem = teiseItem
    //           nuosavybeItem.asmuo = []
    //         }
    //         nuosavybeItem.asmuo.push(...asmuo)
    //       } else {
    //         teises.push(teise)
    //       }
    //     })
    //     if (nuosavybeItem) {
    //       teises.unshift(nuosavybeItem)
    //     }
    //     items.push(...teises)
    //   })

    //   return items
    // },
    saveData(toRoute, afterSave) {
      this.loading = true
      const data = this.turtasData()
      if (data.teises.length === 0) {
        this.loading = false
        return
      }
      this.$axios
        .post(`objektas/${this.objektasID}/turtas/store-ntr-list`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.initialForm()

          this.$root.$emit('updateTurtasList')

          if (toRoute) {
            this.goToRoute()
          } else {
            if (afterSave === 'close') {
              this.closeSearch()
            }
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    turtasData() {
      let teises = []
      this.formData.forEach(item => {
        let dalisList = []
        item.dalys.forEach(dalis => {
          if (dalis.aktyvus) {
            dalisList.push(dalis.dal_id)
          }
        })
        if (dalisList.length > 0) {
          teises.push({
            reg_id: item.reg_id,
            reg_nr: item.reg_nr,
            obj_kodas: item.obj_kodas,
            unikalus_nr: item.unikalus_nr,
            adresas: item.adresas,

            tei_id: item.tei_id,
            teit_tipas: item.teit_tipas,
            teip_potipis: item.teip_potipis,
            dal_id: item.dal_id,
            dal_skaitiklis: item.dal_skaitiklis,
            dal_vardiklis: item.dal_vardiklis,
            tei_pavadinimas: item.tei_pavadinimas,
            dok_id: item.dok_id,

            dalys: dalisList,
          })
        }
      })

      return { teises: teises, pakeistas_tur_id: this.autoSearchTurID ?? null }
    },
    cancelData() {
      this.$store.dispatch('unsavedData', false).then(() => {
        this.closeSearch()
      })
    },
    closeSearch() {
      this.$emit('cancelData')
    },
    cancelSearch() {
      this.formData = []
      this.showResult = false
      this.closeSearch()
    },
    checkTeise(item) {
      item.dalys = item.dalys.map(dalis => {
        dalis.aktyvus = item.aktyvus
        return dalis
      })
    },
    checkDalis(item, dalis) {
      if (item.teit_tipas !== 1) {
        // turtine teise
        item.aktyvus = dalis.aktyvus
        this.checkTeise(item)
        return
      }
      item.aktyvus = false
      item.dalys = item.dalys.map(dalis => {
        if (dalis.aktyvus) {
          item.aktyvus = true
        }
        return dalis
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.teise-label {
  display: inline;

  p {
    margin: 0;
  }
  p.teise-bold {
    font-weight: 600;
  }
}
</style>
